import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { COMPANY_MANAGERS_QUERY_KEY } from "../useGetManagers";
import { requestDeleteManager } from "./deleteManager.request";

const useDeleteManager = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => requestDeleteManager(id),
    ...options,
    onSuccess: (data, variables, ctx) => {
      void queryClient.invalidateQueries({
        queryKey: [COMPANY_MANAGERS_QUERY_KEY]
      });
      options?.onSuccess?.(data, variables, ctx);
    }
  });
};

export default useDeleteManager;
